function simpleArrayEqual(arr1: any[], arr2: any[]) {
    if (arr1.length != arr2.length) {
        return false;
    }

    arr1 = [...arr1].sort();
    arr2 = [...arr2].sort();

    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }
    return true;
}

//// Makes deep comparing of two objects
export function equalDeep(x: unknown, y: unknown, compareArrays = false) {
    if (x === y) {
        return true; // If both x and y are null or undefined and exactly the same
    } else if (!(x instanceof Object) || !(y instanceof Object)) {
        return false; // If they are not strictly equal, they both need to be Objects
    } else if (x.constructor !== y.constructor) {
        // They must have the exact same prototype chain, the closest we can do is
        // Test their constructor.
        return false;
    } else if (Array.isArray(x) && Array.isArray(y)) {

        if  (x.length>0 &&  y.length>0  &&  x[0] instanceof Object &&  y[0] instanceof Object) {
            return true;
        }
        // If both objects are arrays then we're assuming their values are not complex objects, otherwise we cannot do much
        if (!compareArrays) {
            return true;
        }
        return simpleArrayEqual(x, y);
    } else {
        for (const p in x) {
            if (!x.hasOwnProperty(p)) {
                continue; // Other properties were tested using x.constructor === y.constructor
            }
            if (!y.hasOwnProperty(p)) {
                return false; // Allows to compare x[ p ] and y[ p ] when set to undefined
            }
            if (x[p] === y[p]) {
                continue; // If they have the same strict value or identity then they are equal
            }
            if (typeof x[p] !== "object") {
                return false; // Numbers, Strings, Functions, Booleans must be strictly equal
            }
            if (!equalDeep(x[p], y[p], compareArrays)) {
                return false;
            }
        }
        for (const p in y) {
            if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) {
                return false;
            }
        }
        return true;
    }
}
